/* =====================================================================
   CUSTOM: Bestsellers tabs — random pick + tab switching.
   ---------------------------------------------------------------------
   - Each panel holds a pool of product cards rendered by Liquid. On load
     the pool is shuffled (Fisher–Yates) and only data-show cards are
     revealed, so every visit gets a different selection even though the
     page HTML itself is cached.
   - Tabs follow the WAI-ARIA tabs pattern: click or Left/Right/Home/End to
     switch, roving tabindex, active tab styled as the primary button.

   Paired with: sections/bestsellers-tabs.liquid
   ===================================================================== */
(function () {
  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  class BestsellersTabs extends HTMLElement {
    connectedCallback() {
      this.show = parseInt(this.dataset.show, 10) || 4;
      this.tabs = Array.from(this.querySelectorAll('.js-bt-tab'));
      this.querySelectorAll('.bt__grid').forEach((grid) => this.pick(grid));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index, false));
        tab.addEventListener('keydown', (e) => this.onKeydown(e, index));
      });

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => {
          var index = this.tabs.findIndex((tab) => tab.contains(e.target) || e.target.contains(tab));
          if (index > -1) this.select(index, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.onBlockSelect) document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    /* Shuffled cards are re-appended in their new order; the first `show` stay visible. */
    pick(grid) {
      var items = shuffle(Array.from(grid.children));
      items.forEach((item, index) => {
        item.hidden = index >= this.show;
        if (item.hasAttribute('data-cc-animate-delay')) {
          item.setAttribute('data-cc-animate-delay', (index * 0.09).toFixed(2) + 's');
        }
        grid.appendChild(item);
      });
    }

    select(index, moveFocus) {
      this.tabs.forEach((tab, i) => {
        var active = i === index;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('btn--primary', active);
        tab.classList.toggle('btn--secondary', !active);
        if (panel) panel.hidden = !active;
      });
      if (moveFocus) this.tabs[index].focus();
    }

    onKeydown(e, index) {
      var last = this.tabs.length - 1;
      var next = null;
      if (e.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (e.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = last;
      if (next === null) return;
      e.preventDefault();
      this.select(next, true);
    }
  }

  if (!customElements.get('bestsellers-tabs')) {
    customElements.define('bestsellers-tabs', BestsellersTabs);
  }
})();
